<template>
  <div id="app">
    <router-view/> 
    <Header />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
    name: "App",
    components:{
    Header,
    Footer,
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #202223;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/App.vue